import { render, staticRenderFns } from "./car_addoredit.vue?vue&type=template&id=d136922c&"
import script from "./car_addoredit.vue?vue&type=script&lang=js&"
export * from "./car_addoredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports